module.exports = __webpack_public_path__ + "img/15.e2813a0e.png";